module.exports = __webpack_public_path__ + "img/productHome6.05703a55.png";